/* eslint-disable @next/next/no-img-element */
import type {
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  NextPage,
} from "next";
import { MainLayout } from "src/presentation/layouts";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useTranslation } from "next-i18next";
import { settings } from "@config/settings";
import { MainRouter } from "@config/urls";
import { CountryLocationService } from "@services/country-location-service";

import styles from "./canal-etico.module.scss";

import {
  SimpleLink,
  TemplateText,
  Text,
} from "src/presentation/components/atoms";

const Home: NextPage = () => {
  const { t } = useTranslation();

  const TopBanner = () => {
    return (
      <section
        style={{
          backgroundImage: `url(/static/images/nosotros-compromiso-codigo-etico-manvert-bioestimulantes.jpg)`,
        }}
        className={styles.topbanner}
      >
        <div className={styles.card} style={{ justifyContent: "flex-end" }}>
          <Text as="h1">{t("CompromisoView.codigoSection.heading")}</Text>

          <TemplateText template="small">
            {t("CompromisoView.codigoSection.description")}
          </TemplateText>
        </div>
      </section>
    );
  };

  const ProyectoSection = () => {
    return (
      <section className={styles.proyectoSection}>
        <Text as="h2"> {t("CanalEtico.ProyectoSection.titulo")}</Text>
        <TemplateText template="small">
          {t("CanalEtico.ProyectoSection.subtitulo")}
        </TemplateText>
        <div className={styles.items}>
          <ul>
            <li> {t("CanalEtico.ProyectoSection.item1")}</li>
            <li> {t("CanalEtico.ProyectoSection.item2")}</li>
            <li>{t("CanalEtico.ProyectoSection.item3")}</li>
            <li> {t("CanalEtico.ProyectoSection.item4")}</li>
            <li>{t("CanalEtico.ProyectoSection.item5")}</li>
            <li> {t("CanalEtico.ProyectoSection.item6")}</li>
            <li>{t("CanalEtico.ProyectoSection.item7")}</li>
          </ul>
        </div>
      </section>
    );
  };
  const CaracteristicasPrincipales = () => {
    return (
      <section className={styles.proyectoSection}>
        <Text as="h2">{t("CanalEtico.CaracteristicasPrincipales.titulo")}</Text>
        <div className={styles.items}>
          <ul>
            <li>
              {t("CanalEtico.CaracteristicasPrincipales.caracteristica1")}
              <span>
                {t("CanalEtico.CaracteristicasPrincipales.subtexto1")}
              </span>
            </li>
            <li>
              {t("CanalEtico.CaracteristicasPrincipales.caracteristica2")}
              <span>
                {t("CanalEtico.CaracteristicasPrincipales.subtexto2")}
              </span>
            </li>
            <li>
              {t("CanalEtico.CaracteristicasPrincipales.caracteristica3")}
              <span>
                {t("CanalEtico.CaracteristicasPrincipales.subtexto3")}
              </span>
            </li>
            <li>
              {t("CanalEtico.CaracteristicasPrincipales.caracteristica4")}
              <span>
                {t("CanalEtico.CaracteristicasPrincipales.subtexto4")}
              </span>
            </li>
          </ul>
        </div>
      </section>
    );
  };

  const EqualitySection = () => {
    const cards = [
      {
        id: "card1",
        img: "/static/images/canaletico/coresol-app.webp",

        title: t("CanalEtico.EqualitySection.title"),
        texts: [
          t("CanalEtico.EqualitySection.text"),
          <div key={"texto2"}>
            {t("CanalEtico.EqualitySection.text1")}
            <strong className={styles.manverFont} key={"manvert"}>
              manvert
            </strong>
          </div>,
          t("CanalEtico.EqualitySection.text2"),
          t("CanalEtico.EqualitySection.text3"),
          t("CanalEtico.EqualitySection.text4"),
          t("CanalEtico.EqualitySection.text5"),
          t("CanalEtico.EqualitySection.text6"),
        ],
      },
      {
        id: "card2",
        img: "/static/images/canaletico/coresol-web.webp",
        title: t("CanalEtico.EqualitySection.titleCard2"),
        subtitle: t("CanalEtico.EqualitySection.subtitleCard2"),
        link: "https://co-resol.bcnresol.com/webclick",
        texts: [
          <div key={"textoCard2"}>
            {t("CanalEtico.EqualitySection.textCard2")}
            <strong className={styles.manverFont} key={"manvert"}>
              manvert
            </strong>
          </div>,
          t("CanalEtico.EqualitySection.text1Card2"),
          t("CanalEtico.EqualitySection.text2Card2"),
          t("CanalEtico.EqualitySection.text3Card2"),
          t("CanalEtico.EqualitySection.text4Card2"),
          t("CanalEtico.EqualitySection.text5Card2"),
        ],
      },
    ];

    return (
      <section className={styles.proyectoSection}>
        <Text as="h2">{t("CanalEtico.EqualitySection.tituloGeneral")}</Text>
        <Text as="h2">{t("CanalEtico.EqualitySection.subtituloGeneral")}</Text>
        {cards.map((item) => (
          <section key={item.id} className={styles.equalitySection}>
            <div key={item.id} className={styles.card_item}>
              <Text as="h2">{item.title}</Text>

              <ul style={{ textAlign: "center" }}>
                <div className={styles.imagenEtico}>
                  <img alt="" src={item.img} />
                </div>
                <div className={styles.buttonEnlaceCanal}>
                  {item.subtitle && <Text as="h4">{item.subtitle}</Text>}
                  {item.link && (
                    <SimpleLink newtab link={item.link} label={"Co-resol"} />
                  )}
                </div>
                <ol style={{ textAlign: "left" }}>
                  {item.texts.map((text, index) => (
                    <li key={index}>{text}</li>
                  ))}
                </ol>
              </ul>
            </div>
          </section>
        ))}
      </section>
    );
  };

  const ProyectoFooter = () => {
    return (
      <section className={styles.proyectoSection}>
        <Text as="h2"> {t("CanalEtico.footer.titulo")}</Text>
        <TemplateText template="strong">
          {t("CanalEtico.footer.subtitulo")}
        </TemplateText>
      </section>
    );
  };
  return (
    <>
      <NextSeo
        title={t("SEOMeta.CanalEtico.title") || ""}
        description={t("SEOMeta.CanalEtico.description") || ""}
      />
      <MainLayout
        breadcrumb={[
          {
            label: t("urls.home"),
            url: MainRouter.home.generatePath(),
          },
          {
            label: t("urls.nosotros"),
            url: MainRouter.nosotros.generatePath(),
          },
          {
            label: t("urls.canalEtico"),
            url: MainRouter["canal-etico"].generatePath(),
          },
        ]}
      >
        <div className={styles.root}>
          <TopBanner />
          <ProyectoSection />
          <CaracteristicasPrincipales />
          <EqualitySection />
          <ProyectoFooter />
        </div>
      </MainLayout>
    </>
  );
};

export async function getServerSideProps(
  Props: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<any>> {
  const { locale, req, res } = Props;

  let selectedCountry =
    await new CountryLocationService().getSelectedCountryData(req, res);

  return {
    props: {
      country: selectedCountry.countrycode,

      ...(await serverSideTranslations(locale || settings.I18N_FALLBACK, [
        "common",
      ])),
    },
  };
}

export default Home;
